import { render, staticRenderFns } from "./menuNavigation.vue?vue&type=template&id=c281c3d8&scoped=true"
import script from "./menuNavigation.vue?vue&type=script&lang=js"
export * from "./menuNavigation.vue?vue&type=script&lang=js"
import style0 from "./menuNavigation.vue?vue&type=style&index=0&id=c281c3d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c281c3d8",
  null
  
)

export default component.exports